// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f968a302","977":"f463e3ba"}[chunkId] + ".chunk.js";
};